module.exports = __webpack_public_path__ + "img/6e8cf3ac5d624ac592c47f53c4f0d5aa-1440.3a69f174.jpg";